import React, { useEffect, useState, useContext } from "react";
import { Dialog } from "@mui/material";
import Swal from "sweetalert2";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import AppointmentsApi from "../../../../Classes/API/Appointments/AppointmentsApi";
import LinkAccSessToAppHourReq from "../../../../Classes/Models/Requests/Appointments/LinkAccSessToAppHourReq";
import SingleSessionsApps from "./SingleSessionsApps";
import { UserContext } from "App";
import UsersApi from "../../../../Classes/API/UsersApi";
import SearchUserReq from "../../../../Classes/Models/Requests/Users/SearchUser";

const CreateAppointmentPopUp = ({
  GetAppDayById,
  AppDay,
  AppHour,
  ShowCreateAppointment,
  EnableModal,
}) => {
  const User = useContext(UserContext);
  const [AccSession, SetAccSession] = useState({});

  if (!AppHour) return null;

  const swalConfig = {
    target: document.getElementById("appointment-dialog") || "body",
    customClass: {
      container: "swal2-popup-high-z ",
    },
  };

  const handleConfirmCreate = async (session) => {
    if (session.isAdmitted && (!["Admin", "Owner", "HeadAccounting"].includes(User.userType))) {
      Swal.fire({
        ...swalConfig,
        title: "Not Allowed",
        text: "This session is already admitted. Contact admin.",
        icon: "error",
      });
      return;
    }

    const result = await Swal.fire({
      ...swalConfig,
      title: "Confirm Appointment",
      text: `Assign ${session.patientName} to ${AppHour.therapistName}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Create It",
      confirmButtonColor: "#1a73e8",
    });

    if (result.isConfirmed) {
      executeCreate(session);
    }
  };

  const executeCreate = async (session) => {
    Swal.fire({
      ...swalConfig,
      title: "Processing...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    let req = new LinkAccSessToAppHourReq(session.id, AppHour.id, false, false);
    let res = await AppointmentsApi.LinkAccountingSessionToAppointmentHour(req);

    if (res.status === "Success") {
      GetAppDayById(AppDay.id);
      const allowedUsers = [
        "SuperAdmin",
        "Admin", "Owner", "HeadAccounting",
        "AppointmentEmployee",
        "CallCenterEmployee",
        "AccountingEmployee",
      ];
      const canSendWhatsapp = allowedUsers.includes(User.userType);

      const response = await Swal.fire({
        ...swalConfig,
        title: "Success",
        text: "Appointment created successfully!",
        icon: "success",
        showConfirmButton: canSendWhatsapp,
        confirmButtonText: "Send Whatsapp",
        showCancelButton: true,
        cancelButtonText: "Close",
      });

      if (response.isConfirmed && canSendWhatsapp) {
        SendWhatsapp(session.patientId, session);
      }

      EnableModal(false, {});
    } else {
      Swal.fire({
        ...swalConfig,
        title: "Failed",
        text: res.message,
        icon: "error",
      });
    }
  };

  const SendWhatsapp = async (patientId, session) => {
    let req = new SearchUserReq();
    req.patientId = patientId;
    let res = await UsersApi.SearchUsers(req);

    if (res.status === "Success") {
      let patient = res.data.list[0];
      let phone = patient.number.replace(/[^\d]/g, "");
      let appointmentDate = new Date(AppHour.appointmentHourTime);
      let message = `Dear ${patient.name}, your appointment at ${appointmentDate.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })} on ${appointmentDate.toLocaleDateString()} with ${AppHour.therapistName} is confirmed.`;

      window.open(
        `https://web.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(message)}`,
        "_blank",
      );
    }
  };

  return (
    <Dialog
      id="appointment-dialog" // Added ID for Swal target
      open={ShowCreateAppointment}
      onClose={() => EnableModal(false, {})}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        style: {
          height: "90vh",
          maxHeight: "1000px",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          zIndex: 1300, // Standard MUI Dialog Z-index
        },
      }}
    >
      <MDBox
        p={3}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ borderBottom: "1px solid #eee", bgcolor: "#f8f9fa" }}
      >
        <MDBox>
          <MDTypography variant="h5" fontWeight="medium">
            Add Session to Schedule
          </MDTypography>
          <MDTypography variant="button" color="text">
            Assigning to: <b>{AppHour.therapistName}</b> | Time:{" "}
            <b>
              {new Date(AppHour.appointmentHourTime).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </b>
          </MDTypography>
        </MDBox>
        <MDBox textAlign="right">
          <MDTypography variant="caption" display="block" color="secondary">
            SELECTED SESSION
          </MDTypography>
          <MDTypography variant="h6" color={AccSession.id ? "info" : "error"}>
            {AccSession.id ? `ID: ${AccSession.id}` : "None Selected"}
          </MDTypography>
        </MDBox>
      </MDBox>

      <MDBox sx={{ flex: 1, overflowY: "auto", p: 2 }}>
        <SingleSessionsApps
          SetAccSession={(session) => {
            SetAccSession(session);
            handleConfirmCreate(session);
          }}
          isSimplified={true}
        />
      </MDBox>

      <MDBox p={2} textAlign="right" sx={{ borderTop: "1px solid #eee" }}>
        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={() => EnableModal(false, {})}
        >
          Cancel
        </button>
      </MDBox>
    </Dialog>
  );
};

export default CreateAppointmentPopUp;
